import { Component, Input } from '@angular/core';

@Component({
  selector: 'zero-exercise-status',
  templateUrl: './exercise-status.component.html',
  styleUrl: './exercise-status.component.scss',
})
export class ExerciseStatusComponent {
  @Input() totalExcercises: number;
  @Input() completedExcercises: number;
  @Input() isSent: boolean;
}
